function detectCSVDelimiter(csvString, possibleDelimiters = [',', ';', '\t', '|']) {
  const lines = csvString.split(/\r?\n/).slice(0, 10); // Check the first 10 lines
  let delimiterCounts = {};

  possibleDelimiters.forEach(delimiter => {
    delimiterCounts[delimiter] = 0;
  });

  lines.forEach(line => {
    possibleDelimiters.forEach(delimiter => {
      const count = (line.match(new RegExp(`\\${delimiter}`, 'g')) || []).length;
      delimiterCounts[delimiter] += count;
    });
  });

  return Object.entries(delimiterCounts)
    .sort((a, b) => b[1] - a[1]) // Sort by highest occurrence
    .map(entry => entry[0])[0];  // Return the most common delimiter
}

export async function getCSVFileHeaders(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    let headers = null;
    reader.onload = (e) => {
      const csvString = e.target.result;
      // Find delimiter
      const delimiter = detectCSVDelimiter(csvString, [',', ';']);
      // Split the text into an array of lines
      const lines = csvString.split('\n');
      if (lines && lines.length) {
        headers = lines[0]
          .replace(/(\r\n|\n|\r)/gm, '') // Remove line breaks
          .split(delimiter)
          .map(header => header.trim().replace(/^["']|["']$/g, '')); // Remove surrounding quotes
      }
    };
    reader.onloadend = () => {
      resolve(headers);
    };
    reader.readAsText(file);
  });
}